<template>
  <tr v-if="rate">
    <td>{{ tariff?.label || tariff?.name }}</td>
    <td>
      <currency-input
        :name="`rates[${rate?.charge_id?.toString()}][rate]`"
        :readonly="readonly"
        v-model="rate.rate"
      ></currency-input>
    </td>
    <td>
      <select
        name="charge_type_id"
        class="form-control"
        required
        v-model="rate.charge_type_id"
        :disabled="readonly"
      >
        <option value="" disabled readonly>
          Please Select
        </option>
        <option
          :value="type.id"
          :key="index"
          v-for="(type, index) in chargeTypes"
        >
          {{ type.label }}
        </option>
      </select>
    </td>
  </tr>
</template>

<script>
import CurrencyInput from '@/components/Generic/Form/CurrencyInput';

export default {
  props: {
    rates: {
      type: Array,
      required: true
    },
    tariff: {
      type: Object,
      required: true
    },
    isGroup: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    CurrencyInput
  },

  computed: {
    chargeTypes() {
      return this.$store.getters['CreditHireChargeTypes/all'];
    },
    dailyCharge() {
      return this.$store.getters['CreditHireCharges/all'].find(
        charge => charge.name === 'daily'
      );
    }
  },

  data() {
    return {
      rate: undefined
    };
  },

  mounted() {
    this.setRate();
  },

  methods: {
    setRate() {
      let rate = this.rates.find(r =>
        this.isGroup
          ? r.group_id === this.tariff.id
          : r.charge_id === this.tariff.id
      );

      if (!rate) {
        const rateObj = {
          charge_id: this.isGroup ? this.dailyCharge?.id : this.tariff.id,
          charge_type_id: null,
          rate: null
        };

        if (this.isGroup) {
          rateObj.group_id = this.tariff.id;
        }

        const index = this.rates.push(rateObj);
        rate = this.rates[index - 1];
      }

      this.rate = rate;
    }
  }
};
</script>
